import Sortable from "@stimulus-components/sortable"

export default class extends Sortable {
    connect() {
        super.connect()
    }

    onUpdate() {
        const inputs = this.element.querySelectorAll("input.sortable")
        inputs.forEach((input, index) => {
            input.value = index
        })
    }
}
